module.exports = __webpack_public_path__ + "static/img/4_1_5.86a6bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_5.png
// module id = mIuW
// module chunks = 1